import {useMutation} from "react-query";
import {Formik} from "formik";
import {validator} from "@reside/forms";

import {AuthService} from "../../services/AuthService";
import {dispatch} from "../../store";
import {LoginFormWrapper} from "./LoginFormWrapper";

export const PageAdminLogin = () => {
  const {mutate, error, isLoading} = useMutation(AuthService.signIn, {
    onMutate: () => {
      dispatch.adminSession.reset();
    },
    onSuccess: ({data: {user, token}}) => {
      dispatch.adminSession.setUser({
        user,
        isUserLogin: true,
      });
      dispatch.adminSession.setToken({
        token,
        isLoginToken: true,
      });
    },
  });

  return (
    <Formik
      initialValues={{email: "", password: ""}}
      onSubmit={values => {
        mutate({
          ...values,
          email: values.email.toLowerCase().trim(),
        });
      }}
      validate={values =>
        validator.validateAll(values, {
          email: "required",
          password: "required",
        })
      }
    >
      {() => <LoginFormWrapper error={error} isLoading={isLoading} />}
    </Formik>
  );
};
